<template>
  <div class="top-terms">
    <!-- <button
      class="top-terms__smart-filter"
      :class="{
        'top-terms__smart-filter--on': isSmartFilter,
        'top-terms__smart-filter--disabled': isLoading
      }"
      @click.prevent="toggleSmartFilter"
      v-tooltip="{
        theme: 'tooltip-left',
        content: 'Com esse filtro você pode habilitar ou desabilitar<br>palavras menos relevantes da conversa.'
      }"
    >
      Filtro inteligente
    </button> -->

    <div class="top-terms__tabs">
      <ul class="top-terms__tabs__index">
        <li
          v-for="tab in tabsActive"
          :key="tab.key"
          class="top-terms__tabs__index__tab"
          :class="{ 'top-terms__tabs__index__tab--on': tabSelected === tab.key }"
        >
          <a
            :href="`#${tab.key}`"
            @click.prevent="selectTab(tab.key)"
          >
            {{ tab.label }}

            <SvgIconFlag v-if="tab.key === 'topTermsTabTracking'"/>
          </a>
        </li>
      </ul>

      <!-- Tab terms -->
      <div
        v-if="tabSelected === 'topTermsTabMostSpoken'"
        id="topTermsTabMostSpoken"
        class="top-terms__tabs__content"
      >
        <BasePaneCard
          :isLoading="isLoading"
          unboxed
        >
          <div
            v-if="terms.length"
            class="top-terms__container"
          >
            <div class="top-terms__chart">
              <BaseBubbleWord :dataset="chart"/>
            </div>

            <div class="top-terms__list">
              <h4 class="heading heading--smaller">
                Termos frequentes no período
              </h4>

              <div
                class="top-terms__list__search top-terms__list__search--not-found"
                :class="{ 'top-terms__list__search--not-found': !searchTerms.length }"
              >
                <BaseInputSearch
                  placeholder="Pesquisar termo"
                  v-model="search.terms"
                  variation="rounded"
                />

                <Transition name="transition-fade">
                  <div
                    v-show="search.terms && !searchTerms.length"
                    class="top-terms__list__search__not-found"
                  >
                    Termo não encontrado
                  </div>
                </Transition>
              </div>

              <ul>
                <li
                  v-for="term in searchTerms"
                  :key="term.word"
                  class="top-terms__list__item"
                >
                  <div class="top-terms__list__item__percentage">
                    {{ formatPercentageLabel(term) }}
                  </div>

                  <div class="top-terms__list__item__term">
                    {{ term.word }}
                  </div>

                  <div class="top-terms__list__item__tray">
                    <PartialTopTermsButtonTracking :term="term"/>

                    <button
                      class="top-terms__list__item__button top-terms__list__item__button--chat"
                      v-tooltip="{
                        theme: 'tooltip-top-left',
                        content: 'Abrir lista<br>de conversas.'
                      }"
                      @click.prevent="openLeadConversations(term.word)"
                    >
                      <SvgIconChat/>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <BaseEmptyState v-else>
            <template v-if="dataset?.error">
              <SvgIconRobot/>

              <h3>
                Ops! Algo deu errado...
              </h3>

              <p>
                <a
                  href="javascript:;"
                  @click.prevent="fetchData()"
                >
                  Tentar novamente
                </a>
              </p>
            </template>

            <template v-else>
              <SvgIconRunningWithErrors/>

              <h3>
                Nenhum termo para ser exibido.
              </h3>

              <p>
                Confira os filtros selecionados<br>
                e atualize a página.
              </p>
            </template>
          </BaseEmptyState>
        </BasePaneCard>
      </div>

      <!-- Tab trends -->
      <div
        v-if="tabSelected === 'topTermsTabTrends'"
        id="topTermsTabTrends"
        class="top-terms__tabs__content"
      >
        <BasePaneCard
          :isLoading="isLoading"
          unboxed
        >
          <div
            v-if="trendsTerms.length"
            class="top-terms__container"
          >
            <div class="top-terms__chart">
              <BaseBubbleWord :dataset="trendsChart"/>
            </div>

            <div class="top-terms__list">
              <h4 class="heading heading--smaller">
                Tendências do período
              </h4>

              <div
                class="top-terms__list__search top-terms__list__search--not-found"
                :class="{ 'top-terms__list__search--not-found': !searchTrends.length }"
              >
                <BaseInputSearch
                  placeholder="Pesquisar termo"
                  v-model="search.trends"
                  variation="rounded"
                />

                <Transition name="transition-fade">
                  <div
                    v-show="search.trends && !searchTrends.length"
                    class="top-terms__list__search__not-found"
                  >
                    Termo não encontrado
                  </div>
                </Transition>
              </div>

              <ul>
                <li
                  v-for="term in searchTrends"
                  :key="term.word"
                  class="top-terms__list__item"
                >
                  <div
                    class="top-terms__list__item__percentage top-terms__list__item__percentage--diff"
                    :class="`top-terms__list__item__percentage--${term.variation}`"
                  >
                    <span>
                      {{ formatPercentageLabel(term) }}
                    </span>
                  </div>

                  <div class="top-terms__list__item__term">
                    {{ term.word }}
                  </div>

                  <div class="top-terms__list__item__tray">
                    <PartialTopTermsButtonTracking :term="term"/>

                    <button
                      class="top-terms__list__item__button top-terms__list__item__button--chat"
                      v-tooltip="{
                        theme: 'tooltip-top-left',
                        content: 'Abrir lista<br>de conversas.'
                      }"
                      @click.prevent="openLeadConversations(term.word)"
                    >
                      <SvgIconChat/>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <BaseEmptyState v-else>
            <template v-if="dataset?.error || dataset?.termsDiff.error">
              <SvgIconRobot/>

              <h3>
                Ops! Algo deu errado...
              </h3>

              <p>
                <a
                  href="javascript:;"
                  @click.prevent="fetchData()"
                >
                  Tentar novamente
                </a>
              </p>
            </template>

            <template v-else>
              <SvgIconRunningWithErrors/>

              <h3>
                Nenhum termo para ser exibido.
              </h3>

              <p>
                Confira os filtros selecionados<br>
                e atualize a página.
              </p>
            </template>
          </BaseEmptyState>
        </BasePaneCard>
      </div>

      <!-- Tab tracking -->
      <div
        v-if="tabSelected === 'topTermsTabTracking'"
        id="topTermsTabTracking"
        class="top-terms__tabs__content"
      >
        <BasePaneCard
          :isLoading="isLoading"
          unboxed
        >
          <div
            v-if="!dataset?.error"
            class="top-terms__container"
          >
            <div
              v-if="!isLoading"
              class="top-terms__chart"
            >
              <BasePaneCard
                :isLoading="isLoadingTracking"
                unboxed
              >
                <BaseBubbleWord
                  v-if="trackingTerms.length"
                  :dataset="trackingChart"
                />

                <BaseEmptyState v-else>
                  <SvgIconRunningWithErrors/>

                  <h3>
                    Nenhum termo para ser exibido.
                  </h3>

                  <p>
                    Pesquise um termo para ser monitorado.
                  </p>
                </BaseEmptyState>
              </BasePaneCard>
            </div>

            <div class="top-terms__list">
              <h4 class="heading heading--smaller">
                Termos monitorados
              </h4>

              <div
                class="top-terms__list__search top-terms__list__search--not-found"
                :class="{ 'top-terms__list__search--not-found': !searchTracking.length }"
              >
                <BaseInputSearch
                  placeholder="Pesquisar termo"
                  v-model="search.tracking"
                  variation="rounded"
                />

                <Transition name="transition-fade">
                  <div
                    v-show="search.tracking && !searchTracking.length"
                    class="top-terms__list__search__not-found"
                  >
                    Termo não encontrado
                  </div>
                </Transition>
              </div>

              <a
                v-if="search.tracking && !searchTracking.length"
                class="top-terms__list__tracking-add"
                @click.prevent="updateTracking({
                  word: search.tracking,
                  isTracked: false
                })"
              >
                + Monitorar termo <strong>{{ search.tracking }}</strong>
              </a>

              <ul v-else>
                <li
                  v-for="term in searchTracking"
                  :key="term.word"
                  class="top-terms__list__item"
                >
                  <div
                    class="top-terms__list__item__percentage top-terms__list__item__percentage--diff"
                    :class="`top-terms__list__item__percentage--${term.variation === 'new' ? 'zero' : term.variation}`"
                  >
                    <span>
                      {{ term.percentage | percentage }}
                    </span>
                  </div>

                  <div class="top-terms__list__item__term">
                    {{ term.word }}
                  </div>

                  <div class="top-terms__list__item__tray">
                    <PartialTopTermsButtonTracking :term="term"/>

                    <button
                      class="top-terms__list__item__button top-terms__list__item__button--chat"
                      v-tooltip="{
                        theme: 'tooltip-top-left',
                        content: 'Abrir lista<br>de conversas.'
                      }"
                      @click.prevent="openLeadConversations(term.word)"
                      :disabled="term.variation === 'new'"
                    >
                      <SvgIconChat/>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <BaseEmptyState v-else>
            <SvgIconRobot/>

            <h3>
              Ops! Algo deu errado...
            </h3>

            <p>
              <a
                href="javascript:;"
                @click.prevent="fetchData()"
              >
                Tentar novamente
              </a>
            </p>
          </BaseEmptyState>
        </BasePaneCard>
      </div>
    </div>

    <CommonLeadConversations
      :isOpen="isOpenLeadConversations"
      :heading="leadConversationsHeading"
      :urlParams="leadConversations.urlParams"
    />
  </div>
</template>

<script>
import { dateFilter, percentageFilter, capitalizeFilter } from '@/utils/filters'
import BasePaneCard from '@/components/base/BasePaneCard'
import BaseEmptyState from '@/components/base/BaseEmptyState'
import BaseBubbleWord from '@/components/base/BaseBubbleWord'
import BaseInputSearch from '@/components/base/BaseInputSearch'
import CommonLeadConversations from '@/components/common/CommonLeadConversations'
import PartialTopTermsButtonTracking from '@/components/partials/PartialTopTermsButtonTracking'
import { mapState, mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import dayjs from 'dayjs'
import { orderBy, shuffle } from 'lodash'

export default {
  name: 'WidgetTopTerms',

  components: {
    BasePaneCard,
    BaseEmptyState,
    BaseBubbleWord,
    BaseInputSearch,
    CommonLeadConversations,
    PartialTopTermsButtonTracking
  },

  filters: {
    date: dateFilter,
    percentage: percentageFilter,
    capitalize: capitalizeFilter
  },

  data () {
    return {
      isLoading: false,
      isLoadingTracking: false,
      dataset: null,
      isSmartFilter: true,
      tabs: [
        {
          key: 'topTermsTabMostSpoken',
          label: 'Termos mais falados',
          isActive: true
        },
        {
          key: 'topTermsTabTrends',
          label: 'Trends',
          isActive: true
        },
        {
          key: 'topTermsTabTracking',
          label: 'Monitoramento',
          isActive: true
        }
      ],
      tabSelected: 'topTermsTabMostSpoken',
      isOpenLeadConversations: false,
      leadConversations: {
        filter: 'word',
        key: '',
        urlParams: ''
      },
      search: {
        terms: '',
        trends: '',
        tracking: ''
      }
    }
  },

  computed: {
    ...mapState('base', [
      'mainApi',
      'pageFilter'
    ]),

    ...mapGetters('auth', [
      'userId',
      'platformId'
    ]),

    tabsActive () {
      return this.tabs.filter(tab => tab.isActive === true)
    },

    terms () {
      if (!this.dataset || this.dataset.error) {
        return []
      }

      const terms = this.dataset.terms || {}
      const tracking = this.dataset.tracking || {}

      const dataset = Object.entries(terms).map(([word, percentage]) => {
        // Handle potential null values
        percentage = percentage === null ? 0 : percentage

        return {
          word: capitalizeFilter(word),
          percentage,
          isTracked: tracking.hasOwnProperty(word)
        }
      })

      return orderBy(dataset, ['percentage'], ['desc'])
    },

    termsDiff () {
      if (!this.dataset || this.dataset.error) {
        return []
      }

      const dataset = Object.entries(this.dataset.termsDiff).map(item => {
        const [word, percentage] = item

        return {
          word: capitalizeFilter(word),
          percentage,
          isTracked: Object.keys(this.dataset.trackingDiff).includes(word)
        }
      })

      return orderBy(dataset, ['percentage'], ['desc'])
    },

    chart () {
      const dataset = this.terms
        .slice(0, 20)
        .reverse()
        .map((item, index) => {
          return {
            ...item,
            size: (index + 1) * 2
          }
        })

      return shuffle(dataset)
    },

    trendsTerms () {
      if (!this.dataset || this.dataset.error) {
        return []
      }

      const dataset = this.terms.map(term => {
        const termDiff = this.termsDiff.find(item => item.word === term.word)
        let variation = 'new'

        if (termDiff) {
          const percentageDiff = term.percentage - termDiff.percentage

          switch (true) {
            case percentageDiff > 0:
              variation = 'up'
              break

            case percentageDiff < 0:
              variation = 'down'
          }
        }

        const percentage = variation === 'new'
          ? 0
          : termDiff.percentage
            ? ((term.percentage - termDiff.percentage) / termDiff.percentage) * 100
            : 100

        return {
          ...term,
          percentage,
          variation
        }
      })

      return orderBy(dataset, ['percentage'], ['desc'])
    },

    trendsChart () {
      const dataset = this.trendsTerms
        .slice(0, 20)
        .reverse()
        .map((item, index) => {
          return {
            ...item,
            size: (index + 1) * 2
          }
        })

      return shuffle(dataset)
    },

    trackingTerms () {
      if (!this.dataset || this.dataset.error) {
        return []
      }

      const dataset = Object.entries(this.dataset.tracking).map(item => {
        let [word, percentage] = item
        let variation = 'new'

        const percentageDiff = Object.entries(this.dataset.trackingDiff)
          .filter(item => item[0] === word)
          .map(item => item[1])

        if (percentageDiff.length) {
          const diff = percentage - percentageDiff[0]

          switch (true) {
            case diff > 0:
              variation = 'up'
              break

            case diff < 0:
              variation = 'down'
          }
        }

        percentage = variation === 'new'
          ? 0
          : percentageDiff[0]
            ? ((percentage - percentageDiff[0]) / (percentage + percentageDiff[0])) * 100
            : 100

        return {
          word: capitalizeFilter(word),
          percentage,
          variation,
          isTracked: true
        }
      })

      return orderBy(dataset, ['percentage'], ['desc'])
    },

    trackingChart () {
      const dataset = this.trackingTerms
        .filter(item => item.variation !== 'new')
        .slice(0, 20)
        .reverse()
        .map((item, index) => {
          return {
            ...item,
            size: (index + 1) * 2
          }
        })

      return shuffle(dataset)
    },

    searchTerms () {
      const query = this.search.terms.toLowerCase()

      return this.terms.filter(term => {
        return term.word.toLowerCase().includes(query)
      })
    },

    searchTrends () {
      const query = this.search.trends.toLowerCase()

      return this.trendsTerms.filter(term => {
        return term.word.toLowerCase().includes(query)
      })
    },

    searchTracking () {
      const query = this.search.tracking.toLowerCase()

      return this.trackingTerms.filter(term => {
        return term.word.toLowerCase().includes(query)
      })
    },

    leadConversationsHeading () {
      const { key } = this.leadConversations

      return key || ''
    }
  },

  watch: {
    pageFilter () {
      this.fetchData()
    }
  },

  mounted () {
    this.$root.$on('pane-tray-close', this.closeLeadConversations)
    this.$root.$on('tracking-updated', this.fetchData)

    this.fetchData()
  },

  methods: {
    ...mapMutations('smartSummary', {
      setTopTerms: 'SET_TOP_TERMS',
      setTrendsTerms: 'SET_TRENDS_TERMS'
    }),

    selectTab (key) {
      if (this.tabSelected === key) {
        return
      }

      this.tabSelected = key
    },

    getUrlParams () {
      let params = '?'
      let [dateStart, dateEnd] = this.pageFilter.dateRange
      const { action, csat, feeling } = this.pageFilter

      if (!dateStart || !dateEnd) {
        dateStart = dayjs()
        dateEnd = dateStart.add(1, 'day')
      }

      params += `&filter=${this.leadConversations.filter}`
      params += `&key=${this.leadConversations.key}`

      params += `&firstDate=${dateFilter(dateStart, 'base')}`
      params += `&lastDate=${dateFilter(dateEnd, 'base')}`

      if (action.length) {
        params += `&actions=${action.join()}`
      }

      if (csat.length) {
        params += `&csat=${csat.join()}`
      }

      if (feeling.length) {
        params += `&sentiments=${feeling.join()}`
      }

      return params
        .replace(/\?$/, '')
        .replace(/\?&/, '?')
    },

    getFetchDataPayload (isDiffMode) {
      let [dateStart, dateEnd] = this.pageFilter.dateRange
      const { action, csat, feeling, status } = this.pageFilter
      const payload = {
        retrieve_stopwords: this.isSmartFilter,
        retrieve_monitored_words: true,
        top_terms_count: 20
      }

      if (!dateStart || !dateEnd) {
        dateStart = dayjs()
        dateEnd = dateStart.add(1, 'day')
      }

      if (isDiffMode) {
        const daysDiff = dayjs(dateEnd).diff(dateStart, 'day')

        dateEnd = dayjs(dateStart).subtract(1, 'day')
        dateStart = dateEnd.subtract(daysDiff, 'day')
      }

      payload.start_date = dateFilter(dateStart, 'base')
      payload.end_date = dateFilter(dateEnd, 'base')

      if (action.length) {
        payload.action = action
      }

      if (csat.length) {
        payload.csat = csat
      }

      if (feeling.length) {
        payload.sentiments = feeling
      }

      if (status.length) {
        payload.status = status
      }

      return payload
    },

    async fetchData (isTrackingMode) {
      if (isTrackingMode) {
        this.isLoadingTracking = true
      } else {
        this.isLoading = true
      }

      try {
        const payload = this.getFetchDataPayload()
        const payloadDiff = this.getFetchDataPayload(true)
        const url = `${this.mainApi}semantic-word-cloud/bubble-word`

        const responses = [
          axios.post(url, payload),
          axios.post(url, payloadDiff)
        ]

        await axios
          .all(responses)
          .then(axios.spread((
            { data: termsResponse },
            { data: termsDiffResponse }
          ) => {
            const hasErrorTermsResponse = Boolean(termsResponse.error)
            const hasErrorTermsDiffResponse = Boolean(termsDiffResponse.error)
            const isEmptyTermsResponse = !termsResponse.collection_algorithm_frequency
            const isEmptyTermsDiffResponse = !termsDiffResponse.collection_algorithm_frequency

            if (hasErrorTermsResponse) {
              this.dataset = { error: true }

              return
            }

            if (isEmptyTermsResponse) {
              this.dataset = null

              return
            }

            // Modelling new response to ongoing processable format
            const arrayOfTermObjects = termsResponse.terms_retrieved_list.map(item => ({ [item.term]: item.terms_algorithm_percentage * 100 }))
            const arrayOfMonitoredObjects = termsResponse.terms_monitored_list.map(item => ({ [item.term]: item.terms_algorithm_percentage * 100 }))

            const arrayOfTermDiffObjects = termsDiffResponse.terms_retrieved_list.map(item => ({ [item.term]: item.terms_algorithm_percentage * 100 }))
            const arrayOfMonitoredDiffObjects = termsDiffResponse.terms_monitored_list.map(item => ({ [item.term]: item.terms_algorithm_percentage * 100 }))

            const termsObject = Object.assign({}, ...arrayOfTermObjects)
            const monitoredObject = Object.assign({}, ...arrayOfMonitoredObjects)

            const termsDiffObject = Object.assign({}, ...arrayOfTermDiffObjects)
            const monitoredDiffObject = Object.assign({}, ...arrayOfMonitoredDiffObjects)

            this.dataset = {
              terms: termsObject,
              termsDiff: hasErrorTermsDiffResponse
                ? { error: true }
                : isEmptyTermsDiffResponse ? {} : termsDiffObject,
              tracking: monitoredObject,
              trackingDiff: hasErrorTermsDiffResponse ? {} : monitoredDiffObject
            }

            this.setTopTerms(this.terms)
            this.setTrendsTerms(this.trendsTerms)
          }))
      } catch (error) {
        this.dataset = { error }

        throw error
      } finally {
        if (isTrackingMode) {
          this.isLoadingTracking = false
        } else {
          this.isLoading = false
        }
      }
    },

    async updateTracking (term) {
      const { word, isTracked } = term
      const payload = { word }
      let url = `${this.mainApi}semantic-word-cloud/`

      url += isTracked ? 'remove-word' : 'add-word'

      try {
        await axios.post(url, payload)

        this.fetchData(true)
      } catch (error) {
        throw error
      }
    },

    toggleSmartFilter () {
      if (this.isLoading) {
        return
      }

      this.isSmartFilter = !this.isSmartFilter

      this.fetchData()
    },

    formatPercentageLabel (term) {
      return term.variation === 'new'
        ? 'Novo'
        : percentageFilter(term.percentage)
    },

    updateLeadConversations (key) {
      this.leadConversations.key = key
      this.leadConversations.urlParams = this.getUrlParams()
    },

    openLeadConversations (key) {
      this.$root.$emit('pane-tray-close', 'leadConversationsContext')

      this.updateLeadConversations(key)

      this.isOpenLeadConversations = true
    },

    closeLeadConversations (context) {
      if (context === 'leadConversationsContext') {
        this.isOpenLeadConversations = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.top-terms {
  $gap: map-get($layout-insights, 'gap');
  $border: 2px solid nth($colors-custom, 8);
  $border-radius: map-get($layout-insights, 'border-radius');

  position: relative;
  border: $border;
  border-radius: $border-radius;
  background: #fff;

  &__tabs {
    &__index {
      z-index: 2;
      position: relative;

      &__tab {
        display: inline;

        a {
          display: inline-block;
          padding: 15px 40px;
          border: $border;
          border: {
            bottom: 0;
            color: transparent;
          }
          border-radius: $border-radius $border-radius 0 0;
          transform: translate(-2px, -2px);
          font: {
            weight: 700;
            size: 16px;
          }
          color: map-get($colors-util, 'muted');

          svg {
            width: 13px;
            margin-left: 2px;
            fill: map-get($colors-util, 'muted');
          }
        }

        &--on {
          a {
            border-color: nth($colors-custom, 8);
            background: #fff;
            color: nth($colors-custom, 1);

            svg {
              fill: nth($colors-custom, 1);
            }
          }
        }
      }
    }

    &__content {
      z-index: 1;
      position: relative;
      padding: map-get($layout-insights, 'gap');
      border-top: $border;
      transform: translateY(-4px);

      /deep/ {
        .pane-card {
          &__body {
            height: 330px;
          }
        }
      }
    }
  }

  &__smart-filter {
    z-index: 3;
    position: absolute;
    top: 10px;
    right: 30px;
    display: inline-flex;
    height: 32px;
    align-items: center;
    gap: 10px;
    padding: 6px 20px;
    border: 2px solid nth($colors-custom, 1);
    border-radius: 2em;
    transition: all 0.1s;
    background: none;
    color: nth($colors-custom, 1);
    font: {
      weight: 600;
      size: 12px;
    }
    line-height: 100%;

    &::after {
      content: '+';
      display: block;
      transition: all 0.1s;
      font: {
        weight: 500;
        size: 16px;
      }
    }

    &--on {
      background: nth($colors-custom, 1);
      color: #fff;

      &::after {
        transform: rotate(45deg);
      }
    }

    &--disabled {
      cursor: wait;
    }

    &:hover {
      border-color: nth($colors-custom, 2);
      background: nth($colors-custom, 2);
      color: nth($colors-custom, 1);
    }
  }

  &__container {
    display: flex;
    height: 100%;
    justify-content: center;
    align-items: center;
  }

  &__chart {
    flex-grow: 1;

    /deep/ {
      .pane-card {
        &__body {
          height: auto;
        }
      }

      .bubble-word {
        max-width: 540px;
        margin: 0 auto;
      }
    }
  }

  &__list {
    @extend %scrollbar;

    flex: 0 0 370px;
    display: flex;
    height: 100%;
    flex-direction: column;
    gap: 20px;
    padding-left: $gap;
    margin-left: $gap;
    border-left: 1px solid nth($colors-custom, 4);

    ul {
      overflow: auto;
      padding-right: 15px;
    }

    &__item {
      display: flex;
      min-height: 34px;
      gap: 10px;
      border: 1px solid nth($colors-custom, 4);
      border-radius: 8px;
      line-height: 100%;

      &:not(:first-child) {
        margin-top: 8px;
      }

      &__percentage {
        display: flex;
        width: 57px;
        justify-content: flex-end;
        align-items: center;
        font-size: 14px;

        &--diff {
          width: 80px;
          justify-content: flex-start;
          padding-left: 10px;
          border-radius: 8px 0 0 8px;
          background: nth($colors-custom, 1);
          color: #fff;
          font: {
            weight: 600;
            size: 12px;
          }

          span {
            display: inline-block;
            padding-left: 15px;
            background: {
              position: 0 50%;
              repeat: no-repeat;
              size: 12px auto;
            }
          }
        }

        &--up {
          color: nth($colors-custom, 6);

          span {
            background-image: url('~@/assets/img/main/icons/icon-variation-up.svg');
          }
        }

        &--down {
          color: map-get($colors-util, 'muted');

          span {
            background-image: url('~@/assets/img/main/icons/icon-variation-down.svg');
          }
        }

        &--zero {
          background: nth($colors-custom, 4);
          color: nth($colors-custom, 1);

          span {
            background-image: url('~@/assets/img/main/icons/icon-variation-zero.svg');
          }
        }

        &--null {
          background: nth($colors-custom, 4);
          color: nth($colors-custom, 1);

          span {
            background-image: url('~@/assets/img/main/icons/icon-variation-null.svg');
          }
        }

        &--new {
          background: nth($colors-custom, 2);
          color: nth($colors-custom, 1);
        }
      }

      &__term {
        flex-grow: 1;
        display: flex;
        align-items: center;
        font: {
          weight: 600;
          size: 14px;
        }
      }

      &__tray {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 0 10px;
      }

      &__button {
        display: flex;
        width: 13px;
        height: 13px;
        justify-content: center;
        align-items: center;
        padding: 0;
        border: 0;
        background: none;

        &:hover {
          svg {
            fill: nth($colors-custom, 2);
          }
        }

        &--loading {
          opacity: 0.3;
          pointer-events: none;
        }

        svg {
          transition: all 0.1s;
          fill: nth($colors-custom, 1);
        }

        &--tracking {
          width: 13px;
          height: 13px;
        }

        &--chat {
          width: 15px;
          height: 15px;
        }
      }
    }

    &__search {
      position: relative;

      &--not-found {
        /deep/ {
          input {
            padding-right: 160px;
          }
        }
      }

      &__not-found {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
        font: {
          style: italic;
          size: 12px;
        }
      }
    }

    &__tracking-add {
      transition: all 0.1s;
      color: nth($colors-custom, 1);
      font-size: 12px;
      line-height: 140%;

      &:hover {
        color: nth($colors-custom, 2) !important;
      }

      strong {
        font-weight: 700;
      }
    }
  }
}
</style>
